export const PendingApplication = () => {
  return (
    <div className="flex flex-col gap-l px-l py-m">
      <h2 className="m-0 text-2xl font-bold">We won't be a minute!</h2>
      <p className="m-0 text-m font-reg text-structure-20">
        Thanks for signing up to use iwocaPay! We just need to review your
        details. If we've received your request during working hours (Mon
        &ndash; Fri, 9am &ndash; 6pm) we'll get back to you within a few hours,
        otherwise it will be within 2 hours of the next working day.
      </p>
      <p className="m-0 text-m font-reg text-structure-20">
        Get in touch on{' '}
        <a
          className="font-bold text-primary-40 underline"
          href="tel:0203 778 0549"
        >
          0203 778 0549
        </a>
        .
      </p>
    </div>
  );
};
